import { COLORS } from '@/utils/colors';
import { Outlet } from 'react-router-dom';

const CustomQuoteLayout = () => {
  return (
    <div
      style={{ backgroundColor: COLORS.background }}
      className="flex-1 lg:ml-0 overflow-auto bg-[#141417] text-white p-4 md:p-6 lg:p-8">
      <Outlet />
    </div>
  );
};

export default CustomQuoteLayout; 